import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
const RippleBlob = ({ level, size }) => {
  const [rings, setRings] = useState([]);
  const idRef = useRef(0);
  const levelRef = useRef(level);
  useEffect(() => {
    levelRef.current = level;
  }, [level]);
  useEffect(() => {
    let alive = true;
    const loop = () => {
      if (!alive) return;
      const l = levelRef.current;
      if (l > 0.08) {
        setRings((rs) => [...rs, { id: idRef.current++, strength: l, born: performance.now() }]);
      }
      const delay = 180 + (1 - l) * 600;
      setTimeout(loop, delay);
    };
    loop();
    return () => {
      alive = false;
    };
  }, []);
  useEffect(() => {
    const iv = setInterval(() => {
      const now = performance.now();
      setRings((rs) => rs.filter((r) => now - r.born < 2200));
    }, 400);
    return () => clearInterval(iv);
  }, []);
  const coreScale = 1 + level * 0.35;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: size,
        height: size,
        position: "relative",
        display: "grid",
        placeItems: "center"
      },
      "aria-hidden": true,
      children: [
        rings.map((r) => /* @__PURE__ */ jsx(
          "span",
          {
            style: {
              position: "absolute",
              width: size * 0.35,
              height: size * 0.35,
              borderRadius: "50%",
              border: `2px solid rgba(120,255,200,${0.5 * r.strength})`,
              animation: "voice-ripple-out 2.2s ease-out forwards"
            }
          },
          r.id
        )),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              width: size * 0.35,
              height: size * 0.35,
              borderRadius: "50%",
              background: "radial-gradient(circle at 35% 35%, #d8fff0, #2ce39a 55%, #064d33)",
              boxShadow: `0 0 ${20 + level * 60}px rgba(44,227,154,${0.5 + level * 0.4})`,
              transform: `scale(${coreScale})`,
              transition: "transform 80ms ease-out, box-shadow 120ms ease-out"
            }
          }
        ),
        /* @__PURE__ */ jsx("style", { children: `
        @keyframes voice-ripple-out {
          0%   { transform: scale(0.9); opacity: 1; }
          100% { transform: scale(2.6); opacity: 0; }
        }
      ` })
      ]
    }
  );
};
export {
  RippleBlob
};
//# sourceMappingURL=RippleBlob.js.map
